import { AppId, Route } from '@lumapps/router';
import { socialProfile } from '@lumapps/user-profile/routes';
import { USER_PROFILE_VIEW } from '@lumapps/user-profile/types';
import { hexUUIDToBigInt } from '@lumapps/utils/string/hexUUIDToBigInt';

export const BEEKEEPER_INTEGRATION = 'beekeeper-integration';

export enum IFRAMES {
    FORMS = 'forms',
    SURVEYS = 'surveys',
    WORKFLOWS = 'workflows',
}

export const BKPR_ID = 'bk';
export const BKPR_PREFIX = `/${BKPR_ID}`;

export const SUPPORTED_URLS_BY_APPS: Record<string, AppId[]> = {
    '/tasks': [AppId.frontOffice],
    '/forms': [AppId.backOffice, AppId.frontOffice],
    '/surveys': [AppId.backOffice, AppId.frontOffice],
    '/workflows': [AppId.backOffice],
    '/chats': [AppId.frontOffice],
    '/profiles': [AppId.frontOffice],
};

export const APPS_PREFIX_MAPPINGS: Partial<Record<AppId, (url: string) => string>> = {
    [AppId.frontOffice]: (url: string) => url,
    [AppId.backOffice]: (url: string) => {
        const cleanUrl = url.startsWith('/') ? url.slice(1) : url;
        return `/dashboard#${cleanUrl}`;
    },
};

export const MAPPED_ROUTES: Record<string, (url: string) => Route> = {
    '/profiles': (url: string) => {
        const userId = url.split('/profiles/')[1];
        const decimalId = hexUUIDToBigInt(userId);
        return socialProfile({ userId: decimalId, view: USER_PROFILE_VIEW.about, isUserSpaceEnabled: true });
    },
};

export const PREFIXES_FOR_SUPPORTED_ROUTES_LIST = Object.keys(SUPPORTED_URLS_BY_APPS);
export const PREFIXES_FOR_MAPPED_ROUTES_LIST = Object.keys(MAPPED_ROUTES);
